import { MARQUEE } from "../../data";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE, ...MARQUEE, ...MARQUEE];
  return (
    <section data-testid="marquee" aria-hidden="true" className="relative bg-ink border-y border-white/10 py-8 sm:py-10 overflow-hidden">
      <div className="marquee-track">
        {items.map((word, i) => (
          <span key={i} className="mx-8 sm:mx-12 inline-flex items-center gap-8 sm:gap-12">
            <span className="font-display italic text-4xl sm:text-6xl lg:text-7xl font-light text-[var(--paper)]/90">
              {word}
            </span>
            <span className="h-2 w-2 rounded-full bg-glacier" style={{ backgroundColor: "var(--glacier)" }} />
          </span>
        ))}
      </div>
    </section>
  );
};
